// audienceExport — Facebook Custom Audience CSV builder.
// Walks radius_subscribers, normalises BD phones to E.164, and emits
// two segment CSVs (active / discontinued) ready to upload to Meta
// Ads Manager. Admin-only.

import type { ApiClient } from "./client.js";

export interface AudienceExportStats {
  total_rows: number;
  active_raw: number;
  discontinued_raw: number;
  dropped_no_phone: number;
  dropped_bad_phone: number;
  dropped_duplicate: number;
  /** Discontinued rows skipped because the same phone is on an active row.
   *  Prevents the win-back audience from showing ads to customers who've
   *  already re-enrolled under a new username. */
  dropped_reenrolled_from_disc: number;
  final_active: number;
  final_discontinued: number;
}

export interface AudienceExportPreview {
  ok: boolean;
  stats: AudienceExportStats;
  error?: string;
}

export type AudienceSegment = "active" | "discontinued";

export function makeAudienceExportApi(client: ApiClient) {
  return {
    /** Counts what would land in each CSV without actually emitting bytes. */
    preview() {
      return client.get<AudienceExportPreview>("/v1/api/marketing/audiences/preview");
    },
    /** Browser-friendly direct download URL — anchor href, not a fetch call.
     *  Auth flows via the session cookie set on the API origin. */
    downloadURL(segment: AudienceSegment): string {
      return `/v1/api/marketing/audiences/download?segment=${segment}`;
    },
  };
}

export type AudienceExportApi = ReturnType<typeof makeAudienceExportApi>;
